import React from 'react';
import type { Plant } from '../../../../types/plant';
import { Calendar, Scissors } from 'lucide-react';

interface HarvestingProps {
  plant: Plant;
}

export default function Harvesting({ plant }: HarvestingProps) {
  return (
    <section className="bg-white rounded-lg shadow-sm p-6">
      <h2 className="text-2xl font-semibold mb-6">Harvesting Guide</h2>
      <div className="space-y-6">
        {/* When to Harvest */}
        <div className="border-b pb-6">
          <div className="flex items-center gap-2 mb-3">
            <Calendar className="h-5 w-5 text-primary-500" />
            <h3 className="text-lg font-medium">When to Harvest</h3>
          </div>
          <p className="text-gray-600">
            {plant.harvest_indicators || 'No harvest timing information available.'}
          </p>
        </div>

        {/* Harvesting Instructions */}
        <div className="pb-6">
          <div className="flex items-center gap-2 mb-3">
            <Scissors className="h-5 w-5 text-primary-500" />
            <h3 className="text-lg font-medium">Harvesting Instructions</h3>
          </div>
          <p className="text-gray-600">
            {plant.harvest_instructions || 'No harvesting instructions available.'}
          </p>
        </div>
      </div>
    </section>
  );
}